import { Button, Form, Input, message, Modal, Typography, UploadFile } from "antd"
import { useEffect, useState } from "react"
import { configs } from "~/configs"
import Media from "~/modules/media/pages/Media"
import { MediaData } from "~/modules/page"
import { t } from "../../../languages/i18n"
import userService from "../services/userService"
const { Title } = Typography

interface AccountManagementProfileProps {
  userInfo: {
    username: string
    email: string
    firstName: string
    lastName: string
    avatar?: {}
  }
  updateUserInfo: (info: { username: string; email: string; firstName: string; lastName: string; avatar: {} }) => void
}

const AccountManagementProfile = ({ userInfo, updateUserInfo }: AccountManagementProfileProps) => {
  const [form] = Form.useForm()
  const { updateUser } = userService()
  const [fileList, setFileList] = useState<UploadFile[]>([])
  const [userAvatar, setUserAvatar] = useState<string>("")
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [avatar, setAvatar] = useState<MediaData | null>(null)

  useEffect(() => {
    form.setFieldsValue({
      username: userInfo.username,
      email: userInfo.email,
      firstName: userInfo.firstName,
      lastName: userInfo.lastName,
    })
  }, [userInfo, form])

  const onFinish = async () => {
    const storedUser = localStorage.getItem("user")
    const id = storedUser ? JSON.parse(storedUser).id : null

    if (!id) {
      message.error("User ID not found.")
      return
    }
    form.setFieldValue("avatar", avatar)
    const formValues = form.getFieldsValue()

    updateUserInfo({
      username: formValues.username || userInfo.username,
      email: formValues.email || userInfo.email,
      firstName: formValues.firstName || userInfo.firstName,
      lastName: formValues.lastName || userInfo.lastName,

      // avatar: formValues.avatar || userInfo.avatar,
      avatar: 30,
    })

    try {
      const updatedUser = await updateUser(Number(id), formValues)

      localStorage.setItem("user", JSON.stringify(updatedUser))
    } catch (error) {
      console.error("Error during form submission:", error)
      message.error("An error occurred while submitting the form. Please try again.")
    }
  }

  const handleMediaSelect = (media: MediaData) => {
    // setUserAvatar(media.id)
    setUserAvatar(`${configs.API_URL}${media.url}`)
    localStorage.setItem("userAvatar", `${configs.API_URL}${media.url}`)
    setIsModalOpen(false)
    setAvatar(media)
  }

  useEffect(() => {
    const avatarUrl = localStorage.getItem("userAvatar")
    if (avatarUrl) {
      setUserAvatar(avatarUrl)
    }
  }, [])

  const showModal = () => {
    setIsModalOpen(true)
  }

  const handleOk = () => {
    setIsModalOpen(false)
  }

  const handleCancel = () => {
    setIsModalOpen(false)
  }

  return (
    <div>
      <Form form={form} labelCol={{ span: 8 }} wrapperCol={{ span: 16 }} style={{ maxWidth: 600 }} onFinish={onFinish}>
        <Form.Item label={t("Username")} name="username">
          <Input disabled />
        </Form.Item>
        <Form.Item label="Email" name="email">
          <Input />
        </Form.Item>
        <Form.Item label={t("First Name")} name="firstName">
          <Input />
        </Form.Item>
        <Form.Item label={t("Last Name")} name="lastName">
          <Input />
        </Form.Item>
        <Form.Item label={t("New Password")} name="newPassword">
          <Input />
        </Form.Item>
        <Form.Item label={t("Avatar")} name="avatar">
          <div className="flex flex-col">
            {userAvatar && (
              <img src={userAvatar} alt="User Avatar" className="rounded-lg max-w-[200px] max-h-[200px] self-center" />
            )}
            <Button onClick={showModal} className={`${userAvatar ? "mt-4" : ""}`}>
              {t(userAvatar ? "Change Avatar" : "Select Avatar")}
            </Button>
          </div>
        </Form.Item>
        <Modal open={isModalOpen} onOk={handleOk} onCancel={handleCancel} width={1500} height={500}>
          <Media isOpenModal={true} onSelectMedia={handleMediaSelect} />
        </Modal>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            {t("Update Profile")}
          </Button>
        </Form.Item>
      </Form>
    </div>
  )
}

export default AccountManagementProfile
